/**
 * The short addresses (v26.10.040, decision 51): the bare address is the players' link, /wall the
 * projector, /court1 to /court4 the tablets, /courts all four on one screen, /join the players
 * again; the same under /practice for the practice tournament. Each is a 302 to the token link of
 * the moment (worker/src/index.ts, tournament.ts goTo). Only the real day ("main") and the practice
 * ("rehearsal") have them; admin links never do.
 */

export const SHORT = /^\/(?:(practice)(?:\/|$))?(wall|court[1-4]|courts|join)?$/;

/** The path prefix of a tournament's short addresses, or null when it has none. */
export function shortPrefix(tournament: string): string | null {
  if (tournament === "main") return "";
  if (tournament === "rehearsal") return "/practice";
  return null;
}

/**
 * The short address for a screen, from its token link: "wall", "players" or a court number.
 * Falls back to the token link for a tournament without short addresses (a test one).
 */
export function shortLink(link: string, what: "wall" | "players" | "courts" | number, origin?: string): string {
  let url: URL;
  try {
    url = new URL(link, origin ?? "https://bdayminton.technoid.cc");
  } catch {
    return link;
  }
  const prefix = shortPrefix(url.searchParams.get("t") ?? "main");
  if (prefix === null) return url.href;
  const path = what === "wall" ? "/wall" : what === "players" ? "" : what === "courts" ? "/courts" : `/court${what}`;
  return url.origin + (prefix + path || "");
}

/**
 * A short address typed with capitals or a slash at the end (/Wall, /court1/, /Practice/Court2)
 * never reaches the Worker, which only sees the exact forms: the page sends it on to the exact
 * form. Null when the path is not a short address or is already exact.
 */
export function exactShort(pathname: string): string | null {
  const low = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  if (low === pathname || !SHORT.test(low)) return null;
  return low;
}
